import type { Formula } from './types';

export function evalFormula(
    formula: Formula | number | string | null | undefined,
    valuesByKey: Record<string, number | null>,
): number | null {
    if (formula == null) {
        return null;
    }
    if (typeof formula === 'number') {
        return formula;
    }
    if (typeof formula === 'string') {
        return valuesByKey[formula] ?? null;
    }

    const op = formula.op;
    if (op === 'sum') {
        let total = 0;
        for (const item of formula.of) {
            const value = evalFormula(item, valuesByKey);
            if (value != null) {
                total += value;
            }
        }
        return total;
    }
    if (op === 'sub') {
        const a = evalFormula(formula.a, valuesByKey);
        const b = evalFormula(formula.b, valuesByKey);
        if (a == null || b == null) {
            return null;
        }
        return a - b;
    }
    if (op === 'div') {
        const a = evalFormula(formula.a, valuesByKey);
        const b = evalFormula(formula.b, valuesByKey);
        if (a == null || b == null || b === 0) {
            return null;
        }
        return a / b;
    }
    if (op === 'mul') {
        const parts: (number | null)[] = formula.of.map((item) => evalFormula(item, valuesByKey));
        if (parts.some((part) => part === 0)) {
            return 0;
        }
        if (parts.some((part) => part == null)) {
            return null;
        }
        return parts.reduce((product, part) => (product as number) * (part as number), 1);
    }
    throw new Error(`unknown op: ${String((formula as { op?: string }).op)}`);
}

export function formulaDependencies(formula: Formula | number | string | null | undefined): string[] {
    if (formula == null || typeof formula === 'number') {
        return [];
    }
    if (typeof formula === 'string') {
        return [formula];
    }
    const op = formula.op;
    if (op === 'sum' || op === 'mul') {
        return formula.of.flatMap((item) => formulaDependencies(item));
    }
    if (op === 'sub' || op === 'div') {
        return [...formulaDependencies(formula.a), ...formulaDependencies(formula.b)];
    }
    return [];
}
